import React from 'react';
import { Link } from 'react-router-dom';
import styles from './AnimeCard.module.css';

const AnimeCard = ({ anime }) => {
  if (!anime) return null;
  
  // Extract necessary data with fallbacks
  const {
    id,
    title,
    title_english,
    cover_image,
    average_score,
    format,
    season,
    season_year,
    episodes
  } = anime;
  
  // Display title in preferred order (English title if available)
  const displayTitle = title_english || title || 'Unknown Anime';
  
  // Format the season for display (e.g., "Spring 2023")
  const formattedSeason = season && season_year 
    ? `${season.charAt(0) + season.slice(1).toLowerCase()} ${season_year}`
    : season_year 
      ? `${season_year}` 
      : format || '';
  
  return (
    <Link to={`/anime/${id}`} className={styles.card}>
      <div className={styles.imageContainer}>
        <img 
          src={cover_image || '/images/placeholder-cover.jpg'} 
          alt={displayTitle}
          className={styles.image}
          loading="lazy"
        />
        
        {average_score > 0 && (
          <div className={styles.score}>
            {average_score}%
          </div>
        )}
        
        <div className={styles.overlay}>
          <div className={styles.details}>
            {format && <span className={styles.format}>{format}</span>}
            {episodes > 0 && <span className={styles.episodes}>{episodes} eps</span>}
          </div>
        </div>
      </div>
      
      <div className={styles.info}>
        <h3 className={styles.title}>{displayTitle}</h3>
        {formattedSeason && (
          <div className={styles.season}>{formattedSeason}</div>
        )}
      </div>
    </Link>
  );
};

export default AnimeCard; 